// Workflow PlanDefinition constants

export const PLAN_DEFINITION_SYSTEM = 'http://polarissleep.com/plan-definitions';
export const ACTIVITY_DEFINITION_SYSTEM = 'http://polarissleep.com/activity-definitions';
export const WORKFLOW_CATEGORY_CODE = 'workflow';

/**
 * PlanDefinition identifiers matching the data/plan-definitions.json bundle.
 */
export const PLAN_DEFINITIONS = {
  REFERRAL_INTAKE: 'referral-intake-workflow',
  PATIENT_INTAKE_ELIGIBILITY: 'patient-intake-eligibility-workflow',
  REFER_OUT: 'refer-out-workflow',
  HSAT_FULFILLMENT: 'hsat-fulfillment-workflow',
  DME_INITIATION_ADHERENCE: 'dme-initiation-adherence-workflow',
  PATIENT_SATISFACTION: 'patient-satisfaction-outcomes-workflow',
} as const;

export type PlanDefinitionCode = (typeof PLAN_DEFINITIONS)[keyof typeof PLAN_DEFINITIONS];

/**
 * RequestGroup identifiers matching the CSV specification.
 */
export const REQUEST_GROUPS = {
  NEW_PATIENT_INTAKE_PCP_REFER: 'NewPatientIntakePCPReferRequestGroup',
  NEW_PATIENT_INTAKE: 'NewPatientIntakeRequestGroup',
  NEW_PATIENT_REFER_OUT: 'NewPatientReferOut',
  PATIENT_HSAT: 'PatientHSATRequestGroup',
  PATIENT_TREATMENT_PLAN: 'PatientTreatmentPlanRequestGroup',
  PATIENT_ADHERENCE: 'PatientAdherenceRequestGroup',
  PATIENT_SATISFACTION_SURVEY: 'PatientSatisfactionSurveyRequestGroup',
} as const;

/**
 * Named conditions used in PlanDefinition action.condition elements.
 * Evaluated at runtime by the condition-evaluator service.
 */
export const WORKFLOW_CONDITIONS = {
  MEDICARE_OR_VIRGINIA: 'medicare-or-virginia',
  DME_INDICATED: 'dme-indicated',
  REFERRING_PROVIDER_EXISTS: 'referring-provider-exists',
} as const;

/**
 * Maps appointment type codes to the workflow action ID that should be
 * completed when an encounter of that type is created (i.e., scheduled).
 */
export const APPOINTMENT_TO_WORKFLOW_ACTION: Record<string, string> = {
  'new-patient-intake': 'schedule-intake-appointment',
};

/**
 * Cross-workflow transition map: when a terminal task completes in one workflow,
 * which PlanDefinition should be instantiated next.
 */
export const WORKFLOW_TRANSITIONS: Record<string, PlanDefinitionCode> = {
  // Referral Intake -> Patient Intake & Eligibility
  'outreach-patient-create-account': PLAN_DEFINITIONS.PATIENT_INTAKE_ELIGIBILITY,
  // Patient Intake & Eligibility -> HSAT Fulfillment (when HSAT approved)
  'approve-hsat-testing': PLAN_DEFINITIONS.HSAT_FULFILLMENT,
  // Patient Intake & Eligibility -> Refer-Out (when in-lab required, handled by hsat-triage bot)
  'indicate-patient-testing-path-refer-out': PLAN_DEFINITIONS.REFER_OUT,
  // HSAT Fulfillment -> DME Initiation (when DME indicated)
  'submit-diagnosis-treatment-plan': PLAN_DEFINITIONS.DME_INITIATION_ADHERENCE,
  // DME Initiation -> Patient Satisfaction (after treatment plan started)
  'request-patient-use-dme': PLAN_DEFINITIONS.PATIENT_SATISFACTION,
};
